module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_kouku-c35f5f68957173ef4a6c207fed1739cc.png";